<template>
  <v-container fluid>
    <v-row no-gutters dense class="flex-nowrap mb-n6" v-if="item.category === 'number'">
      <v-col cols="6">
        <v-text-field
            v-model="item.name"
            :label="$t('name')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="true"
        >
        </v-text-field>
      </v-col>
      <v-col cols="6" v-if="item.category === 'number'">
        <v-text-field
            v-model.number="item.value"
            @input="item.value = $event !== '' && typeof item.value == 'number' ? $event : null"
            :label="$t('value')"
            type="number"
            dense
            outlined
            class="no-spin mx-1"
            :filled="readonly"
            :readonly="readonly"
            :error="item.property_state.value.error"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters dense class="flex-nowrap mb-n6" v-if="item.category === 'text'">
      <v-col cols="6">
        <v-text-field
            v-model="item.name"
            :label="$t('name')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="true"
        >
        </v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
            v-model="item.value"
            :label="$t('value')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="readonly"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters dense class="flex-nowrap mb-n6" v-if="item.category === 'select'">
      <v-col cols="6">
        <v-text-field
            v-model="item.name"
            :label="$t('name')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="true"
        >
        </v-text-field>
      </v-col>
      <v-col cols="6">
        <v-select
            v-model="item.value"
            :items="item.select_list"
            :label="$t('value')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="readonly"
        >
        </v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import commonFunction from "@/commonFunction/commonFunction"
import NumberField from "@/components/Base/NumberField";


export default {
  name: 'BaseAttribute',
  props: {
    item: {type: [Object], default: {}},
    readonly: {type: [Boolean], default: false},
    showDeleted: {type: [Boolean], default: true},
  },

  components: {
    NumberField,
  },

  computed: {
  },

  watch: {
    item: {
      handler(newValue, oldValue) {
        // console.log('watch')
        if (this.item.category === 'select')
          this.select_list_text = this.item.select_list.join("\r\n")
        this.emitValue()
      },
      deep: true
    },
  },

  methods: {
    emitValue() {
      // console.log('emitValue')
      this.$emit('update:item', this.item)
    },
    onChangeSelectListText() {
      // console.log('onChangeSelectListText', this.select_list_text)
      this.item.select_list = this.select_list_text.split(/\r?\n/).filter(row => row.trim() !== '' && !!row.trim())
    },

  },

  async mounted() {
    if (this.item.category === 'select')
      this.select_list_text = this.item.select_list.join("\r\n")
  },

  data() {
    return {
      select_list_text: null,
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "name": "Name",
    "value": "Value",
    "select": "Select",
    "category": "Category",
    "default": "Default",
    "min_value": "Min value",
    "max_value": "Max value"
  },
  "de": {
    "name": "Name",
    "value": "Wert",
    "select": "Wählen",
    "category": "Kategorie",
    "default": "Standard",
    "min_value": "Mindestwert",
    "max_value": "Maximalwert"
  }
}
</i18n>
